import React from 'react';
import { Button, Form, Input, Modal, Rate, message } from 'antd';
import { StarOutlined } from '@ant-design/icons';
import { createPostReview } from '@/apis/posts';
import usePrivateAction from '@/utils/usePrivateAction';
import UserIdentity from '@/components/useridentity';
import DialogHeading from '@/components/dialogheading';
import './index.scss';

const ReviewForm = ({ postId, target, open, onCancel, onSaved }) => {
  const [form] = Form.useForm();
  const { busy, run } = usePrivateAction();
  return <Modal centered width={520} title={<DialogHeading icon={<StarOutlined />} title="评价伙伴" description="记录这次参与体验，帮助彼此建立信任" />} open={open} footer={null}
    destroyOnHidden closable={!busy} mask={{ closable: !busy }} keyboard={!busy} onCancel={() => !busy && onCancel()}>
    <div className="reviewForm">
      <div className="reviewForm-target"><span>评价对象</span><UserIdentity user={target} fallback="伙伴" size={36} /></div>
      <p className="dialogForm-note">双方提交后才会互相展示，提交后不能修改。</p>
      <Form form={form} layout="vertical" disabled={busy} clearOnDestroy onFinish={values => run(
        () => createPostReview(postId, { ...values, target_user_id: target.id }),
        () => { form.resetFields(); message.success('评价已提交'); onSaved(); },
      )}>
        <Form.Item name="rating" label="评分" rules={[{ required: true, message: '请选择评分' }, { type: 'number', min: 1, max: 5, message: '评分需要在 1～5 星之间' }]}><Rate /></Form.Item>
        <Form.Item name="comment" label="评价内容（可选）"><Input.TextArea placeholder="分享合作或活动中的具体感受" maxLength={500} showCount autoSize={{ minRows: 3, maxRows: 6 }} /></Form.Item>
        <div className="dialogForm-actions"><Button disabled={busy} onClick={onCancel}>取消</Button><Button type="primary" htmlType="submit" loading={busy} disabled={!target?.id}>提交评价</Button></div>
      </Form>
    </div>
  </Modal>;
};
export default ReviewForm;
